import { AppState } from '../types';
import { PageTourState } from './slice';

export const pageTourStateSelector = (state: AppState): PageTourState => state.tour;
